package data;

import cerastes.LocalizationManager;
import game.GameState;
import cerastes.Utils;
import cerastes.file.CDParser;
import cerastes.LocalizationManager.LocalizedString;
import cerastes.CMath;

enum abstract PartType(Int) from Int to Int
{
	var Capacitor;
	var SoundChip;
	var Processor;

	var PartType_Max;
}

enum abstract ConsoleMfg(Int) from Int to Int
{
	var Invalid = -1;
	var MilleniumMakina;
	var CALICOMP;
	var Alicenet;
	var Zenon;

	var ConsoleMfg_Max;
}

enum abstract ConsoleType(Int) from Int to Int
{
	var Invalid = -1;
	var MakinaSunset;
	var WonderPet;
	var PocketAlice;
	var Alice68k;
	var PocketGame;
	var AndromedaNeko;
	var MilleniumStarforce;
	var AndromedaTiger;

	var ConsoleType_Max;
}


// pcbs
@:structInit class ConsolePartPlacementDef
{
	@default(0) public var type: PartType = Capacitor;
	@default(0) public var value: Int = 0;
	@default(0) public var x: Int = 0;
	@default(0) public var y: Int = 0;
}

@:structInit class ConsolePCBDef
{
	@default(0) public var console: ConsoleType = 0;
	@default(0) public var manufacturer: ConsoleMfg = 0;
	public var bootSequence: String = "ui/mm_sunset_boot.ui";
	public var sprite: String = 'atlases/ui.catlas|andromedaneko';
	@serializeType("data.ConsolePartPlacementDef")
	public var parts: Array<ConsolePartPlacementDef> = [];
	public var pcbWidth: Int;
	public var pcbHeight: Int;
}

// parts

@:structInit class PartDef
{
	@default(0) public var type: PartType = Capacitor;
	@default(0) public var value: Int = 0;
	public var name(get, never): String;
	public var sprite: String = "#FF00FF";
	public var tint: String = "FFFFFF";

	function get_name()
	{
		return switch( type )
		{
			case Capacitor: return LocalizationManager.localize('part_capacitor_$value');
			case SoundChip: return LocalizationManager.localize('part_sound_$value');
			case Processor: return LocalizationManager.localize('part_proc_$value');
			case PartType_Max: return "????";
		}
	}
}

@:structInit class PartsFile
{
	@serializeType("data.PartDef")
	public var parts: Array<PartDef> = [];
}

@:structInit class ConsolesFile
{
	@serializeType("data.ConsolePCBDef")
	public var consoleParts: Array<ConsolePCBDef> = [];
}

@:build(cerastes.macros.Callbacks.CallbackGenerator.build())
@:structInit class Parts
{
	static var consoleParts: Array<ConsolePCBDef> = [];
	static public var parts: Array<PartDef> = [];

	public static function loadParts()
	{
		var data: PartsFile = CDParser.parse( hxd.Res.data.parts.entry.getText(), PartsFile );
		parts = data.parts;

		var data: ConsolesFile = CDParser.parse( hxd.Res.data.consoles.entry.getText(), ConsolesFile );
		consoleParts = data.consoleParts;
	}

	public static function getConsole( console: ConsoleType )
	{
		for( p in consoleParts)
		{
			if( p.console != console )
				continue;

			return p;
		}
		return null;
	}

	public static function getConsolesByMfg( mfg: ConsoleMfg )
	{
		var out = [];
		for( console in consoleParts )
		{
			if( console.manufacturer == mfg )
				out.push( console );
		}
		return out;
	}

	public static function getParts(console: ConsoleType )
	{
		var parts: Array<PartDef> = [];
		for( p in consoleParts)
		{
			if( p.console != console )
				continue;

			for( cp in p.parts )
			{
				parts.push( lookupPart( cp.type, cp.value ));
			}
				

		}

		return parts;
	}

	public static function lookupPart( type: PartType, num: Int ): PartDef
	{
		for( p in parts )
		{
			if( p.type == type && p.value == num )
				return p;
		}

		return null;
	}

	public static function lookupConsolePart( type: PartType, console: ConsoleType ): PartDef
	{
		var consoleParts = getParts( console );
		var pid = -1; 
		for( c in consoleParts )
		{
			if( c.type == type )
			{
				pid = c.value;
				break;
			}
		}

		for( p in parts )
		{
			if( p.type == type && p.value == pid )
				return p;
		}

		return null;
	}

	public static function localizeConsoleType( t: ConsoleType )
	{
		return LocalizationManager.localize('console_type_${t}');
	}

	public static function localizePartType( t: PartType )
	{
		return LocalizationManager.localize('part_type_${t}');
	}

	public static function localizeMfgType( t: ConsoleMfg )
	{
		return LocalizationManager.localize('company_${t}');
	}

	
}